import React from 'react';
import { createSanitizedMarkup } from '@fiverr-private/futile';
import { constants } from '../../lib';
import FiverrContext from '../FiverrContext';
import propTypes from './propTypes';

/**
 * A unified renderer function for both React 15 and React 16 runtimes.
 * @param  {String} k The translation key.
 * @param  {String} [locale] The session locale.
 * @param  {Object} [params] Interpolated parameters object.
 * @param  {Boolean} [parseMarkup] Indicates whether the translation strings contains markup to be parsed out.
 * @return {String|HTMLSpanElement} Localized translation.
 */
const render = ({
    k,
    parseMarkup = false,
    params = {},
    locale = constants.DEFAULT_LOCALE
}) => {
    if (!k) {
        return null;
    }

    let output;

    try {
        output = i18n.t(k, { ...params, $scope: locale });
    } catch (e) {
        output = k;
    }

    if (parseMarkup) {
        return (
            <span dangerouslySetInnerHTML={createSanitizedMarkup(output)}/>
        );
    }

    return output;
};

const I18n = ({ k, params = {}, parseMarkup = false }) => {
    const { locale } = React.useContext(FiverrContext);

    return render({ k, params, parseMarkup, locale });
};

const I18nReact15 = ({ k, params = {}, parseMarkup = false }) => {
    const locale = params.locale;

    return render({ k, params, parseMarkup, locale });
};

const I18nWrapper = (props) => (
    typeof React.useContext !== 'function'
        ? <I18nReact15 {...props}/>
        : <I18n {...props}/>
);

I18n.propTypes = {
    ...propTypes
};

I18nReact15.propTypes = {
    ...propTypes
};

I18nWrapper.propTypes = {
    ...propTypes
};

export default I18nWrapper;
